import { render, staticRenderFns } from "./eventDialog.vue?vue&type=template&id=4fb9e9ee&scoped=true&"
import script from "./eventDialog.vue?vue&type=script&lang=js&"
export * from "./eventDialog.vue?vue&type=script&lang=js&"
import style0 from "./eventDialog.vue?vue&type=style&index=0&id=4fb9e9ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb9e9ee",
  null
  
)

export default component.exports